const translate = (el, { value, expression }, { effect }) => {

    effect(() => {
        const translations = window[`_server_translations_${value}`];
        if (!translations) {
            console.warn(`No translations found for ${value}`);
        }

        const translation = translations.translations[expression];
        if (!translation) {
            console.warn(`No translation found for ${expression}`);
        }

        el.textContent = translation;
    });

};

export { translate };